{
  "name": "ai-gateway-admin",
  "version": "0.1.0",
  "private": true,
  "type": "module",
  "description": "Management frontend for a multi-server AI gateway supporting Codex, Grok, Gemini, and Claude",
  "packageManager": "pnpm@11.19.0",
  "scripts": {
    "start": "vite",
    "dev": "vite",
    "dev:no-mock": "vite --mode no-mock",
    "dev:test": "vite --mode test",
    "dev:pre": "vite --mode pre",
    "build": "tsc --noEmit && vite build",
    "build:no-mock": "tsc --noEmit && vite build --mode no-mock",
    "build:test": "tsc --noEmit && vite build --mode test",
    "build:pre": "tsc --noEmit && vite build --mode pre",
    "preview": "vite preview",
    "openapi": "orval",
    "test": "vitest run",
    "test:coverage": "vitest run --coverage",
    "test:ui": "vitest --ui",
    "test:watch": "vitest",
    "test:e2e": "pnpm build && playwright test",
    "audit:lighthouse": "node scripts/lighthouse.mjs",
    "typecheck": "tsc --noEmit",
    "lint": "biome check .",
    "check:upgrade-manifest": "node scripts/check-pro-upgrade-manifest.mjs",
    "check": "pnpm typecheck && pnpm lint && pnpm test && npx antd lint ./src --format json && pnpm check:upgrade-manifest && pnpm build"
  },
  "dependencies": {
    "@ant-design/icons": "6.3.4",
    "@ant-design/plots": "2.6.8",
    "@ant-design/pro-components": "3.1.14-7",
    "@dnd-kit/core": "^6.3.1",
    "@dnd-kit/sortable": "^10.0.0",
    "@dnd-kit/utilities": "^3.2.2",
    "@tanstack/react-query": "5.103.1",
    "antd": "6.6.5",
    "antd-style": "4.1.0",
    "clsx": "2.1.1",
    "dayjs": "1.11.23",
    "go-captcha-react": "1.0.5",
    "react": "19.3.0",
    "react-dom": "19.3.0",
    "react-intl": "10.2.2",
    "react-router-dom": "7.18.4",
    "ua-parser-js": "1.0.41",
    "zustand": "5.0.15"
  },
  "devDependencies": {
    "@ant-design/cli": "6.6.5",
    "@babel/parser": "7.29.8",
    "@biomejs/biome": "2.5.14",
    "@playwright/test": "^1.63.0",
    "@tailwindcss/vite": "4.3.3",
    "@testing-library/dom": "10.4.2",
    "@testing-library/jest-dom": "7.0.1",
    "@testing-library/react": "16.3.3",
    "@types/node": "22.20.2",
    "@types/react": "19.3.0",
    "@types/react-dom": "19.3.0",
    "@types/ua-parser-js": "0.7.39",
    "@vitejs/plugin-react": "6.1.1",
    "@vitest/coverage-v8": "4.1.10",
    "@vitest/ui": "4.1.10",
    "happy-dom": "20.11.2",
    "lighthouse": "^13.5.0",
    "orval": "8.35.0",
    "tailwindcss": "4.3.3",
    "typescript": "7.0.2",
    "vite": "8.3.0",
    "vite-plugin-fake-server": "2.2.4",
    "vitest": "4.1.10"
  },
  "engines": {
    "node": ">=22.12.0"
  }
}
